<template>
  <common-dialog ref="dialog" width="400px" show-save-button title="更换用户名" id-key="userId" :data="data"
    :form-rules="rules" :save-func="saveDataFunc" @close-saved="$emit('close-saved')" close-on-saved>
    <template slot="form">
      <el-form-item prop="userName" label-width="0">
        <el-input v-model="data.userName" placeholder="请输入用户名"></el-input>
      </el-form-item>
    </template>
  </common-dialog>
</template>
<script>
import editDialogMixin from '@/mixins/editDialog';
import commonDialog from '@/components/common/dialog';

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      api: require('@/api/wx/mall').default,
      data: {
        userId: null,
        userName: "",
      },
      rules: {
        userName: [{ required: true, message: '用户名不能为空' }],
      },
    };
  },
  methods: {
    saveDataFunc() {
      return new Promise((resolve, reject) => {
        var data = {
          userId: this.data.userId,
          userName: this.data.userName,
          saveType: 0 // 0：保存用户名，1：保存密码
        }
        this.api.saveUser(data).then(res => {
          if (!res) {
            var userInfoStr = localStorage.getItem("user-info");
            var userInfo = JSON.parse(userInfoStr);
            userInfo.userName = data.userName;
            localStorage.setItem("user-info", JSON.stringify(userInfo));
          }
          resolve({ Code: 0, Msg: null })
        }).catch((error) => {
          reject(error)
        })
      })
    }
  },
};
</script>
